<template>
    <div id="dynamic-pricing-expert-rule">
        <div :class="loadMask"></div>

        <div class="dynamic-pricing-expert">
            <DragComponent :name="name" @getName="getName" :errors="errors" :formulaService="formulaService"
                           :formulaAttributesService="formulaAttributesService"
                           :formulaValueService="formulaValueService"
            />
            <div class="row">
                <div class="col-lg-12">
                    <p class="formulas">{{ serial }}</p>
                    <div>
                        <DropComponent :input="input" :formulaService="formulaService"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12" v-for="(error, index) in errors" v-if="isNumber(index)">
                    <span class="error">{{ t(error) }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <button class="btn btn-success"
                            @click.prevent="submit"
                    >{{ t('Submit') }}
                    </button>
                </div>
            </div>
        </div>

        <DragComponent :name="name" @getName="getName" :errors="errors" :formulaService="formulaService"
                       :formulaAttributesService="formulaAttributesService"
                       :formulaValueService="formulaValueService"
                       class="drag-component"
        />
    </div>
</template>

<script>
import DragComponent from "@/components/DynamicPricingRule/DragComponent.vue";
import DropComponent from "@/components/DynamicPricingRule/DropComponent";
import {Drag, Drop, DropMask} from "vue-easy-dnd";
import Input from "@/Models/pricingRulesInterface/Input.ts";
import FormulaService from "@/Models/pricingRulesInterface/FormulaService.ts";
import Formula from "@/Models/pricingRulesInterface/Formula.ts";
import Argument from "@/Models/pricingRulesInterface/Argument.ts";
import ActionComponent from "@/components/grid/ActionComponent.vue";
import {isNumber} from "lodash/lang";

export default {
    name: "dynamic-pricing-expert-rule",
    components: {
        ActionComponent,
        Drag,
        Drop,
        DropMask,
        DropComponent,
        DragComponent
    },
    props: {
        config: {
            Type: Object
        },
        eventBus: {
            type: Object,
        },
        extraData: {
            Type: Object,
        },
    },
    data: function () {
        return {
            loadMask: '',
            formulaService: new FormulaService(),
            formulaAttributesService: new FormulaService(),
            formulaValueService: new FormulaService(),
            formulaValueDefinition: {
                "name": "INPUT",
                "args": [],
                "returnType": "any"
            }
            ,
            input: new Input('root', 'any', new Formula('args', 'any').addArgs(new Argument('args', 'any', true))),
            serial: null,
            name: '',
            errors: null,
            events: []
        };
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    mounted() {
        this.mountEvents();
        this.setValueDefinitions();
        this.getFormulas();
    },
    methods: {
        isNumber,
        mountEvents() {
            let eventManagerService = this.$root.getEventManager();
            eventManagerService.bindEvents(this.defaultBindEvents(), this);

            this.$root.$on('dynamic-pricing-expert-rule:getSerial', () => {
                this.getSerial();
            });
        },
        unmountEvents() {
            let eventManagerService = this.$root.getEventManager();
            eventManagerService.unbindEvents(this.defaultBindEvents());

            this.events.forEach(e => {
                this.eventBus.$off(e);
            });
        },
        defaultBindEvents() {
            let componentIndex = this.getComponentIndex();

            return [
                {
                    name: 'getFormulas',
                    componentIndex: componentIndex,
                },
                {
                    name: 'getData',
                    componentIndex: componentIndex,
                },
                {
                    name: 'getSerial',
                    componentIndex: componentIndex
                },
                {
                    name: 'errorMessage',
                    componentIndex: componentIndex
                },
                {
                    name: 'setFormData',
                    componentIndex: componentIndex
                },
                {
                    name: 'removeLoadMask',
                    componentIndex: componentIndex
                }
            ];
        },
        addLoadMask() {
            this.loadMask = 'lmask';
        },
        removeLoadMask() {
            this.loadMask = '';
        },
        getSerial() {
            this.serial = this.input.serialize();
        },
        getComponentIndex() {
            return `${this.config.index}`;
        },
        getFormulas() {
            let urlFormulas = this.config.getFormulas.url;
            let urlAttributes = this.config.getAttributes.url;

            this.addLoadMask();

            this.$http.get(urlFormulas, []).then(response => {
                let formulas = response.body.data;

                this.setFormulasDefinitions(formulas);
                this.$http.get(urlAttributes, []).then(response => {
                    let attributes = response.body.data

                    this.setAttributesDefinitions(attributes);
                    this.getData();
                }, response => {
                    this.errorMessage(response.body);
                    this.removeLoadMask();
                })

                this.getData();

            }, response => {
                this.errorMessage(response.body);
                this.removeLoadMask();
            })
        },
        setAttributesDefinitions(data) {
            for (const key in data) {
                let name = data[key]['attr'];
                let returnType = 'any';
                let formulaObj = new Formula(name, returnType);


                this.formulaAttributesService.add(formulaObj);
            }
        },
        setValueDefinitions() {
            let formulaValue = this.formulaValueDefinition;
            let name = formulaValue.name;
            let returnType = formulaValue.returnType;
            let formulaObj = new Formula(name, returnType);

            this.formulaValueService.add(formulaObj);
        },
        setFormulasDefinitions(data) {
            for (const key in data) {
                let formula = data[key];
                let formulaObj = new Formula(formula.name, formula.returnType);

                for (let arg of formula.args) {
                    formulaObj.addArgs(new Argument(arg.name, arg.type, arg.required));
                }

                this.formulaService.add(formulaObj);
            }
        },
        getData() {
            let eventManagerService = this.$root.getEventManager();
            let internalGetDataEvent = this.config.emitEvents['getData'] || [];
            let componentIndex = this.getComponentIndex();

            internalGetDataEvent.push({
                type: 'frontend',
                config: {
                    eventName: `${componentIndex}:removeLoadMask`,
                }
            });
            internalGetDataEvent.push({
                type: 'frontend',
                config: {
                    eventName: `${componentIndex}:getSerial`,
                }
            });

            if (undefined !== this.extraData) {
                eventManagerService.emitEvents(internalGetDataEvent, [{'state': {"ruleName": this.extraData.name}}]);
            } else {
                this.removeLoadMask();
            }
        },
        setFormData(config, data) {
            this.$root.$emit('recursive-drop:insertInputs', data.stack, 0, this.input);
            this.name = data.name;
        },
        getFormData() {
            this.getSerial();

            let data = {
                name: this.name,
                type: 'CustomRuleType',
                formula: this.serial
            }

            if (undefined !== this.extraData) {
                data.id = this.extraData.id;
                data.ruleName = this.extraData.name;
            }

            return data
        },
        getName(name) {
            this.name = name;
        },
        submit() {
            this.addLoadMask();

            let eventManagerService = this.$root.getEventManager();
            let params = this.getFormData();
            let internalSubmitEvent = this.config.emitEvents['submit'] || [];
            let componentIndex = this.getComponentIndex();

            internalSubmitEvent.push({
                type: 'frontend',
                config: {
                    eventName: `${componentIndex}:removeLoadMask`,
                }
            });

            eventManagerService.emitEvents(internalSubmitEvent, [{'state': params}]);
        },
        errorMessage(config, data) {
            this.errors = data.errors;
        }
    }
};
</script>

<style>
.drag {
    margin: 5px;
}

.drop-allowed {
    background-color: rgba(0, 255, 0, 0.2);
}

.drop-forbidden {
    background-color: #d4d4d4;
}

.drop-in {
    box-shadow: 0 0 5px rgba(0, 0, 255, 0.4);
}

.drop-box {
    border: 1px solid black;
    min-height: 50px;
    padding: 20px;
}

.formulas {
    width: 100%;
    padding: 10px;
    word-wrap: break-word;
    display: inline-block;
}

.drag-component {
    position: absolute;
    background-color: white;
    top: 0;
    width: calc(100% - 5px);
}

.dynamic-pricing-expert {
    overflow-y: scroll;
    height: 890px;
    position: relative;
    overflow-x: hidden;
}

.error {
    color: red;
}

</style>



// WEBPACK FOOTER //
// DynamicPricingRuleExpertComponent.vue?07f3df9c